/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundSplitDto
 */
export interface RefundSplitDto {
    /**
     * 
     * @type {number}
     * @memberof RefundSplitDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof RefundSplitDto
     */
    refundAmount: string;
}

/**
 * Check if a given object implements the RefundSplitDto interface.
 */
export function instanceOfRefundSplitDto(value: object): value is RefundSplitDto {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('refundAmount' in value) || value['refundAmount'] === undefined) return false;
    return true;
}

export function RefundSplitDtoFromJSON(json: any): RefundSplitDto {
    return RefundSplitDtoFromJSONTyped(json, false);
}

export function RefundSplitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundSplitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'refundAmount': json['refundAmount'],
    };
}

export function RefundSplitDtoToJSON(json: any): RefundSplitDto {
    return RefundSplitDtoToJSONTyped(json, false);
}

export function RefundSplitDtoToJSONTyped(value?: RefundSplitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'refundAmount': value['refundAmount'],
    };
}

